import moment from 'moment';
import { handleActions } from 'redux-actions';

import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';

export const namespace = 'bannersPublicationEditor';

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const SET_INITIAL_VALUES = `${namespace}/set-initial-values`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;

const FETCH_BANNERS_SUCCESS = `${namespace}/fetch-banners-success`;
const FETCH_BANNERS_ERROR = `${namespace}/fetch-banners-error`;

// initial state
const initialState = {
	data: null,
	isLoading: true,
	isError: false
};

const initialFormValues = {
	title: '',
	campaign: [],
	content: [],
	display_at: ''
};

function mapResponseDataToStateData(data) {
	return {
		title: data.title,
		campaign: [{ value: data.campaign.id, label: data.campaign.title }],
		content: [{ value: data.content.id, label: data.content.title }],
		display_at: data.display_at || ''
	};
}

function getCreatePublicationRequest(data) {
	return http({
		url: endpoints.BANNERS.PUBLICATIONS,
		method: 'post',
		actions: [SET_INITIAL_VALUES, FETCH_DATA_ERROR],
		data
	});
}

function getUpdatePublicationRequest(id, data) {
	return http({
		url: `${endpoints.BANNERS.PUBLICATIONS}/${id}`,
		method: 'put',
		actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR],
		data
	});
}

// actions
export const actions = {
	own: {
		fetchData: (props) => (dispatch) => {
			const publicationId = props.params.id;

			if (!publicationId) {
				return dispatch({ type: SET_INITIAL_VALUES });
			}

			const request = http({
				url: `${endpoints.BANNERS.PUBLICATIONS}/${publicationId}`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			});

			return request(dispatch);
		},
		onSubmit: (values, _, props) => (dispatch) => {
			const publicationId = props.params.id;
			const payload = {
				title: values.title,
				campaign_id: values.campaign[0].value,
				content_id: values.content[0].value,
				display_at: values.display_at ? moment(values.display_at).utc().format() : null
			};

			dispatch(actions.own.toggleProgressBar());

			const request = publicationId
				? getUpdatePublicationRequest(publicationId, payload)
				: getCreatePublicationRequest(payload);

			return request(dispatch);
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR }),
		bannerContentsLookup: (search) => (dispatch) => {
			const request = http({
				url: endpoints.LOOKUPS.BANNER_CONTENTS,
				method: 'get',
				actions: [FETCH_BANNERS_SUCCESS, FETCH_BANNERS_ERROR],
				query: { query: search }
			});

			return request(dispatch).then((action) => {
				if (action.type === FETCH_BANNERS_SUCCESS) {
					return {
						options: action.payload.data.map(({ id, title }) => ({ value: id, label: title }))
					};
				}
			});
		}
	}
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: mapResponseDataToStateData(action.payload.data),
			isLoading: false,
			isError: false
		}),
		[SET_INITIAL_VALUES]: (state, action) => ({
			...state,
			data: initialFormValues,
			isLoading: false,
			isError: false
		}),
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		})
	}
);

// reducers
export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field]
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/publication/editor/index.js